import { components } from "./api";

export type Company = components["schemas"]["Company"];
export type CompanyBilling = components["schemas"]["CompanyBilling"];

export interface CompanyWithBillings extends Company {
  billings: CompanyBilling[];
}

export enum IntegrationType {
  DV360 = "DV360",
  TABOOLA = "Taboola",
  OUTBRAIN = "Outbrain",
  SPOTIFY = "Spotify",
  HIVESTACK = "Hivestack",
  AMAZON = "Amazon DSP",
  META = "Meta",
  TIKTOK = "TikTok",
  GOOGLE_ADS = "Google Ads",
  REDDIT = "Reddit",
}

export interface IntegrationColors {
  background: string;
  text: string;
}
